import { gql } from '@apollo/client';
import { BenchmarkReportIcon } from 'spw-redux/modules/benchmark-reports/types';
import { graphqlClient } from './utils';

export const updateBenchmarkReportIconsApi = (
  benchmarkReportIcons: BenchmarkReportIcon[],
  benchmarkReportId: number
) => {
  return graphqlClient.query<{ reportIcons: BenchmarkReportIcon[] }>({
    fetchPolicy: 'no-cache',
    query: gql`
      mutation UpdateBenchmarkReportIcons(
        $benchmarkReportIcons: [BenchmarkReportIconArgs]!
        $benchmarkReportId: Int!
      ) {
        reportIcons: updateBenchmarkReportIcons(
          benchmarkReportIcons: $benchmarkReportIcons
          benchmarkReportId: $benchmarkReportId
        ) {
          id
          iconPath
          cardType
          iconType
        }
      }
    `,
    variables: {
      benchmarkReportIcons,
      benchmarkReportId,
    },
  });
};
